import type * as Blockly from 'blockly/core';
import { expr } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['string_oled'] = function (block: Blockly.Block): [string, number] {
        const text = block.getFieldValue('TEXT') ?? '';
        return expr(`"${text.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`);
    };
}
